import TranslationsTable from 'components/Translations/TranslationsTable';
import useActions from 'hooks/useActions';
import { useEffect } from 'react';

const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        program: state.PEPrograms.selectedProgram,
        translations: state.PEPrograms.translations,
        page: state.PEPrograms.translations_page,
        per_page: state.PEPrograms.translations_per_page,
        total: state.PEPrograms.translations_total,
        total_pages: state.PEPrograms.translations_total_pages,
        isLoading: state.PEPrograms.translations_is_loading,
        selectedTranslation: state.PEPrograms.selectedTranslation,
    };
}

const PEProgramTranslations = connect(mapStateToProps)(function (props) {
    const {
        program,
        translations,
        page,
        per_page,
        total,
        total_pages,
        isLoading,
        selectedTranslation,
        onSaveCallback,
    } = props;

    const {
        PE_FETCH_PROGRAM_TRANSLATIONS_REQUEST,
        PE_POST_PROGRAM_TRANSLATION_REQUEST,
        PE_UPDATE_PROGRAM_TRANSLATION_REQUEST,
        PE_DELETE_PROGRAM_TRANSLATION_REQUEST,
        PE_SELECT_PROGRAM_TRANSLATION,
    } = useActions();

    function onNext() {
        PE_FETCH_PROGRAM_TRANSLATIONS_REQUEST({
            programId: program?.id,
            page: page + 1,
            per_page,
        });
    }

    function onPrev() {
        PE_FETCH_PROGRAM_TRANSLATIONS_REQUEST({
            programId: program?.id,
            page: page - 1,
            per_page,
        });
    }

    function onPageSelected(selectedPage) {
        PE_FETCH_PROGRAM_TRANSLATIONS_REQUEST({
            programId: program?.id,
            page: selectedPage,
            per_page,
        });
    }

    function onPerPageSelected({ perPage }) {
        PE_FETCH_PROGRAM_TRANSLATIONS_REQUEST({
            programId: program?.id,
            per_page: perPage,
        });
    }

    function onDelete(translation) {
        PE_DELETE_PROGRAM_TRANSLATION_REQUEST({
            programId: program?.id,
            page,
            per_page,
            translationId: translation.id,
        });
    }

    function onUpdate(translation) {
        PE_UPDATE_PROGRAM_TRANSLATION_REQUEST({translation, callback: onSaveCallback});
    }

    function onCreate(translation) {
        PE_POST_PROGRAM_TRANSLATION_REQUEST({
            resourceId: program.id,
            translation,
            callback: onSaveCallback,
        });
    }

    useEffect(() => {
        PE_FETCH_PROGRAM_TRANSLATIONS_REQUEST({ programId: program?.id });
        return () => {
            PE_SELECT_PROGRAM_TRANSLATION(null);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <TranslationsTable
            page={page}
            perPage={per_page}
            onNext={onNext}
            onPrev={onPrev}
            onPageSelected={onPageSelected}
            onPerPageSelected={onPerPageSelected}
            isLoading={isLoading}
            total={total}
            totalPages={total_pages}
            onDelete={onDelete}
            translations={translations}
            onSelect={PE_SELECT_PROGRAM_TRANSLATION}
            onCreate={onCreate}
            onUpdate={onUpdate}
            selectedTranslation={selectedTranslation}
        />
    );
});

export default PEProgramTranslations;
